import { render, staticRenderFns } from "./footer_content.vue?vue&type=template&id=a5dc17b2&"
import script from "./footer_content.vue?vue&type=script&lang=js&"
export * from "./footer_content.vue?vue&type=script&lang=js&"
import style0 from "./footer_content.vue?vue&type=style&index=0&id=a5dc17b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports